module.exports = __webpack_public_path__ + "static/media/douplex-up.88727ffb.webp";